import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { BusinessStatus } from './BusinessStatus';
import { CallDropdown } from './CallDropdown';
import { LOGO, navLinks } from '../data/site';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => { setMobileMenuOpen(false); }, [location.pathname, location.hash]);
  const links = (prefix) => navLinks.map((link) => {
    const isSection = link.path.includes('#');
    const active = `${location.pathname}${location.hash}` === link.path;
    return (
      <Link key={link.id} to={link.path} data-testid={`${prefix}-${link.id}`} aria-current={active ? (isSection ? 'location' : 'page') : undefined}
        className={active ? 'active' : ''} onClick={() => setMobileMenuOpen(false)}>{link.name}</Link>
    );
  });
  return (
    <header className="site-header" data-testid="site-header">
      <a href="#main-content" className="skip-link" data-testid="skip-to-content">Skip to content</a>
      <div className="site-container nav-row">
        <Link to="/" className="brand-logo" data-testid="nav-logo" aria-label="Performance Lube 915 home">
          <img src={LOGO} alt="Performance Lube 915" width="160" height="67" />
        </Link>
        <nav className="desktop-links" aria-label="Main navigation" data-testid="desktop-navigation">{links('nav')}</nav>
        <div className="nav-actions">
          <BusinessStatus /><CallDropdown />
          <button className="mobile-menu-toggle" type="button" data-testid="mobile-menu-toggle"
            aria-label={mobileMenuOpen ? 'Close navigation' : 'Open navigation'} aria-expanded={mobileMenuOpen}
            aria-controls="mobile-navigation" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            {mobileMenuOpen ? <X size={23} /> : <Menu size={23} />}
          </button>
        </div>
      </div>
      {mobileMenuOpen && <nav className="mobile-navigation site-container" id="mobile-navigation" aria-label="Mobile navigation"
        data-testid="mobile-navigation" onKeyDown={(event) => { if (event.key === 'Escape') setMobileMenuOpen(false); }}>{links('mobile-nav')}</nav>}
    </header>
  );
};
export default Navbar;